import * as s from './DockManagement.styles'
import DocksTable from '../../components/DocksTable/DocksTable'
import { Typography } from '@mui/material'
import ModalCreateDock from '../../components/ModalCreateDock/ModalCreateDock'
import ButtonCreateDock from '../../components/ButtonCreateDock/ButtonCreateDock'
import { SelectMui } from 'src/components/SelectMui'
import { useSelector } from 'src/utils/store'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import React from 'react'
import { actions } from '../../DockManagementState'
import { selectFulfillmentCenters } from 'src/features/selector'

const DockManagement = () => {
  const [isOpenModalCreateDock, setOpenModalCreateDock] = React.useState(false)
  const [idFc, setIdFc] = React.useState<string>('')

  const dispatch = useDispatch()
  const fulfillmentCenters = useSelector(selectFulfillmentCenters)

  const { register, formState: { errors } } = useForm({
    defaultValues: {
      'fc-filter-select': idFc || '',
    },
  })

  const resolveFcOptions = () =>
    fulfillmentCenters.map((fulfillmentCenter) => ({
      id: fulfillmentCenter.id,
      description: fulfillmentCenter.name,
    }))

  const setSelectedFc = (value: string) => {
    setIdFc(value)
    const fcId = value ? parseInt(value, 10) : undefined
    dispatch(actions.getDocks({ fc_id: fcId }))
  }

  return (
    <s.Container>
      <Typography variant='h5' fontWeight='bold' textAlign='center'>Gestão de Docas</Typography>
      <div style={{ width: '300px', margin: 'auto' }}>
        <SelectMui
          size='small'
          label='FC'
          id='fc-filter-select'
          options={resolveFcOptions()}
          value={idFc}
          onChange={(event) => setSelectedFc(event.target.value as string)}
          inputProps={{ ...register('fc-filter-select', { required: 'Campo obrigatório' }) }}
          error={!!errors['fc-filter-select']}
          helperText={errors['fc-filter-select']?.message}
        />
      </div>
      <DocksTable />
      <ButtonCreateDock setOpenModalCreateDock={setOpenModalCreateDock} />
      <ModalCreateDock
        setIsOpen={setOpenModalCreateDock}
        isOpen={isOpenModalCreateDock}
      />
    </s.Container>
  )
}

export default DockManagement
